import { readonly, ref } from 'vue'

const isPatientListingUpdated = ref(false)

export const usePatientListing = (): any => {
  const updatePatientListing = (isUpdated: boolean) => {
    isPatientListingUpdated.value = isUpdated
  }

  return {
    isPatientListingUpdated: readonly(isPatientListingUpdated),
    updatePatientListing,
  }
}
